import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5fdbf244"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hello-modal__content" }

import { ref, watch } from 'vue';
import { useUserStore } from '@/stores/user';
import { useInternalization } from '@/composables/useInternalization';


export default /*#__PURE__*/_defineComponent({
  __name: 'HelloModal',
  setup(__props) {

const userStore = useUserStore();
const { t } = useInternalization();

const isShow = ref(false);
let isShowed = false;

watch(
  () => userStore.isLogged,
  () => {
    if (userStore.isLogged) {
      showModal();
    } else {
      isShowed = false;
    }
  }
);

function showModal() {
  if (!isShowed && userStore.user.alias) {
    isShow.value = true;
    isShowed = true;
    setTimeout(() => {
      isShow.value = false;
    }, 2000);
  }
}

setTimeout(() => showModal());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['hello-modal', { 'hello-modal--is-show': isShow.value }])
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('hello')) + ", " + _toDisplayString(_unref(userStore).user.alias) + "! ", 1)
  ], 2))
}
}

})